import React, { FunctionComponent } from 'react';

const PrivacyPolicy: FunctionComponent = () => <div className="borderStyle">Privacy and Policy</div>;

export default PrivacyPolicy;
